.root {
  --checkbox--color-disabled-text: var(--theme--color--dark-grey--main);

  &.disabled {
    &,
    .label {
      color: var(--checkbox--color-disabled-text);
    }
  }

  &.compact {
    .wrapper {
      padding: 0;
    }
  }

  .checkbox {
    margin-top: 2px;
  }

  .wrapper {
    display: flex;
    align-items: flex-start;
    gap: var(--theme--sizing--15x);
    padding: var(--theme--sizing--1x);
    cursor: pointer;
  }

  .inputWrapper {
    display: flex;
    align-items: center;
    height: calc(var(--theme--typo--paragraph--size) * var(--theme--typo--paragraph--line-height));
  }
}
